import React, { useState } from 'react'
import { Button, Card, Form, Input } from 'reactstrap'
import { AiOutlineMail, AiOutlineEye, AiOutlineEyeInvisible, AiOutlineLock } from "react-icons/ai";
import profile from '../../images/login-profile.png'
import { Link } from 'react-router-dom';
import LoginComponent from './LoginComponent';
import NotAuthCMS from '../../components/not-auth/NotAuthCMS';
import { useTranslation } from 'react-i18next';

const LoginPage = () => {
    const [viewPass, setViewPass] = useState(false)
    const [formData, setFormData] = useState({ mail: "", password: "" })
    const [isRMe, setIsRMe] = useState(false)
    const { t } = useTranslation();
    const handleLogin = LoginComponent();

    const handleSubmit = (e) => {
        e.preventDefault();
        handleLogin(formData);
    };

    return (
        <NotAuthCMS>
            <div className='login-page'>
                <Card className='login-card'>
                    <div className='w-100 d-flex justify-content-center'><img src={profile} alt='' /></div>
                    <div className='w-100 d-flex justify-content-center'><strong>{t("login")}</strong></div>
                    <div className='w-100 d-flex justify-content-center'><span>{t("login_text")}</span></div>
                    <hr />
                    <Form onSubmit={handleSubmit}>
                        <div>
                            <label htmlFor="email">{t("eposta")}</label>
                            <div className='form-element'>
                                <AiOutlineMail size={18} />
                                <Input
                                    id="email"
                                    name="email"
                                    type='text'
                                    placeholder='info@liberyus.com'
                                    value={formData.mail}
                                    onChange={e => setFormData({ ...formData, mail: e.target.value })}
                                    required
                                />
                            </div>
                        </div>
                        <div className='mt-3'>
                            <label htmlFor="password">{t("password")}</label>
                            <div className='form-element'>
                                <AiOutlineLock size={18} />
                                <Input
                                    id="password"
                                    name="password"
                                    type={viewPass ? 'text' : 'password'}
                                    placeholder='* * * * * * * * *'
                                    value={formData.password}
                                    onChange={e => setFormData({ ...formData, password: e.target.value })}
                                    required
                                />
                                <div onClick={() => setViewPass(!viewPass)} style={{ cursor: 'pointer' }}>
                                    {viewPass ? <AiOutlineEyeInvisible size={18} /> : <AiOutlineEye size={18} />}
                                </div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between mt-3'>
                            <div className='d-flex ml-4 justify-content-start'>
                                <Input
                                    type='checkbox'
                                    id="rememberMe"
                                    className='mr-2 cp'
                                    checked={isRMe}
                                    onChange={e => setIsRMe(e.target.checked)}
                                />
                                <label htmlFor="rememberMe" className='rme-text cp'>{t("remember_me")}</label>
                            </div>
                            <div>
                                <Link to="/forgot-password">{t("forgot_password")}</Link>
                            </div>
                        </div>
                        <Button type="submit" color='primary' className='w-100 mt-3'>{t("login")}</Button>
                    </Form>
                </Card>
            </div>
        </NotAuthCMS>
    )
}

export default LoginPage